import { Component, OnInit, Input, TemplateRef, ViewChild, OnDestroy, Output, EventEmitter } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { PHBHPFeaturePackageConfigurationService } from '../../configure/ph-bhp-feature-package-configuration.service';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { Ward } from '../../configure/Models/Ward';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { AppConfig } from 'src/app/app.config';
import { Router } from '@angular/router';
import { TranslationKeys } from 'ph-bhp-localization';

@Component({
  selector: 'app-ph-bhp-observe-manage-quota',
  templateUrl: './ph-bhp-observe-manage-quota.component.html',
  styleUrls: ['./ph-bhp-observe-manage-quota.component.css'],
})
export class PhBhpObserveManageQuotaComponent implements OnInit, OnDestroy {
  translationKeys: typeof TranslationKeys = TranslationKeys;
  subscription: Subscription;
  gridData: any[];
  institutionID: number;
  institutions: any;
  userData: any;
  itemChange: boolean = false;
  searchText;
  InstitutionsList: [any];
  modalRef: BsModalRef;
  @ViewChild('delmodal') delmodal: TemplateRef<any>;
  @ViewChild('template') template: TemplateRef<any>;
  selectedInstitution
  deleteDataItem
  deleterowIndex
  pageInfo = {
    items: this.translationKeys.Dashboard.Quotas,
    itemsPerPageLabel: 'CONFIGURE.PER_PAGE.QUOTAS'
  };
  selected = false;
  wardModelGridEdit: any = new UntypedFormGroup({
    wardName: new UntypedFormControl('', Validators.compose([Validators.required, Validators.maxLength(60)])),
    departmentID: new UntypedFormControl('', Validators.compose([Validators.required, Validators.maxLength(60)]))
  });

  mygroup = new UntypedFormGroup({
    selectedIns: new UntypedFormControl(this.selected)
  });

  horizontalAction = true;

  fields = [
    { 'field': 'wardName', 'title': this.translationKeys.Configure.Ward, },
    {
      'field': 'departmentName', 'title': this.translationKeys.Configure.Department,
      // 'ngTemplate': (dataItem) => {
      //   return `${this.layoutService.translateText(dataItem.departmentName)}`;
      // }
    },
    {
      'field': 'departmentTypeName', 'title': 'CONFIGURE.DEPARTMENT_TYPE',
      // 'ngTemplate': (dataItem) => {
      //   return `${this.layoutService.translateText(dataItem.departmentName)}`;
      // }
    },
    { 'field': 'numberOfDays', 'title': 'CONFIGURE.NUMBER_OF_DAYS', },
    {
      'field': 'startDateTime', 'title': 'CONFIGURE.START_DATE',
      // "ngTemplate": (dataItem) => {
      //   const startDateTime = this.layoutService.convertUTCStingToLocalDate(dataItem.startDateTime);
      //   const lang = localStorage.getItem('selectedlanguage');
      //   return `${startDateTime.toLocaleDateString(lang, { month: "short", day: "numeric", year: "numeric" })}`;
      // }
    },
    {
      'field': 'endDateTime', 'title': 'CONFIGURE.END_DATE',
      // "ngTemplate": (dataItem) => {
      //   const endDateTime = this.layoutService.convertUTCStingToLocalDate(dataItem.endDateTime);
      //   const lang = localStorage.getItem('selectedlanguage');
      //   return `${endDateTime.toLocaleDateString(lang, { month: "short", day: "numeric", year: "numeric" })}`;
      // }
    },
    { 'field': 'observedQuotas', 'title': 'CONFIGURE.OBSERVED_OBSERVATION' },
    { 'field': 'totalQuotas', 'title': 'CONFIGURE.TOTAL_QUOTA', },
    {
      'field': 'status', 'title': 'USER_MANAGEMENT.STATUS',
      // "ngTemplate": (dataItem) => {
      //   let canShowDelete = true;
      //   let canShowEdit = true;
      //   if (dataItem.status == 1 || dataItem.status == 2) {
      //     canShowDelete = false;
      //   }
      //   if (dataItem.status == 1) {
      //     canShowEdit = false;
      //   }
      //   let actionItems = JSON.parse(JSON.stringify(this.actionItems));
      //   if (!canShowDelete) {
      //     let removableIndex = actionItems.findIndex(el => el.name == "LAYOUT_MODULE.DELETE");
      //     actionItems.splice(removableIndex, 1);
      //   }
      //   if (!canShowEdit) {
      //     let removableIndex2 = actionItems.findIndex(el => el.name == this.translationKeys.LayoutModule.Edit );
      //     actionItems.splice(removableIndex2, 1);
      //   }
      //   let filtered = [];
      //   for (var arr in this.actionItems) {
      //     for (var filter in actionItems) {
      //       if (this.actionItems[arr].name == actionItems[filter].name) {
      //         filtered.push(this.actionItems[arr]);
      //       }
      //     }
      //   }
      //   dataItem.actionItems = filtered;
      //   switch (dataItem.status) {
      //     case 1:
      //       return `${this.layoutService.translateText(this.translationKeys.Configure.Completed)}`;
      //       break;
      //     case 2:
      //       return `${this.layoutService.translateText('INSTITUTION_MANAGEMENT.ACTIVE')}`;
      //       break;
      //     default:
      //       return `${this.layoutService.translateText(this.translationKeys.Configure.Scheduled)}`;
      //       break;
      //   }
      // }
    }
  ];
  filterSubmitted = false;
  showFilter = false;
  filterCount = 0;
  statuses: number[] = [2];
  selectedStatuses: number[] = [2];
  dateRange: Date[];
  selectedDateRange: Date[];
  range = {
    start: null,
    end: null
  }

  constructor(
    private service: PHBHPFeaturePackageConfigurationService,
    private layoutService: PHBHPLayoutPackageService,
    private modalService: BsModalService,
    public translate: TranslateService,
    public config: AppConfig,
    private router: Router
  ) {
    this.dateRange = [null, null];
    this.selectedDateRange = [null, null];
    this.setFilterCount();
  }

  ngOnInit() {
    if (this.layoutService.institutionID) {
      this.institutionID = this.layoutService.institutionID;
      this.getQuotasByInstitutionId();
      this.institutions = this.config.institutions;
      this.OnInstitutionsChanges()
      this.userData = this.config.userData;
    }
    this.subscription = this.layoutService.institutionIDSubject.asObservable().subscribe((res) => {
      this.institutionID = this.layoutService.institutionID;
      this.getQuotasByInstitutionId()
      this.institutions = this.config.institutions;
      this.OnInstitutionsChanges()
      this.userData = this.config.userData;
    });

    this.subscription = this.layoutService.lang.asObservable().subscribe((changedLang) => {
      this.changeGridLang();
    });
  }
  actionItems: any = [
    {
      name: this.translationKeys.LayoutModule.Edit, imgSrc: 'assets/ph-bhp-layout/svg/icon-edit.svg', onClick: (dataItem) => { this.edit(dataItem) },
      canShow: (dataItem) => {
        switch (dataItem.status) {
          case 1:
            return false;
            break;
          default:
            return true;
            break;
        }
      },
    },
    {
      name: 'LAYOUT_MODULE.DELETE', imgSrc: 'assets/ph-bhp-layout/svg/icon-delete.svg', onClick: (dataItem) => { this.openDeleteModal(this.delmodal, dataItem) },
      canShow: (dataItem) => {
        switch (dataItem.status) {
          case 1:
          case 2:
            return false;
            break;
          default:
            return true;
            break;
        }
      },
    }
  ];

  ngOnDestroy() {
    if (this.subscription)
      this.subscription.unsubscribe();
  }

  getQuotasByInstitutionId() {
    this.layoutService.showLoader = true;
    this.service.getQuotasByInstitutionId(this.institutionID).subscribe((res) => {

      this.layoutService.showLoader = false;

      res.forEach((value, index) => {
        res[index].departmentNameTrl = this.layoutService.translateText(value.departmentName);
        res[index].wardTrl = this.layoutService.translateText(value.wardName);
      });

      res = res.filter(quota => quota.wardID != 0);

      if (this.selectedStatuses.length > 0) {
        if (!this.selectedStatuses.includes(0)) {
          res = res.filter(quota => this.selectedStatuses.includes(quota.status));
        }
      }

      if (this.range.start && this.range.end) {
        res = res.filter(quota => {
          const startDateTime = new Date(quota.startDateTime);
          const endDateTime = new Date(quota.endDateTime);
          if (startDateTime >= this.range.start && startDateTime <= this.range.end) {
            return true;
          }

          if (endDateTime >= this.range.start && endDateTime <= this.range.end) {
            return true;
          }

          if (startDateTime <= this.range.start && endDateTime >= this.range.end) {
            return true;
          }

          return false;
        });
      }

      let that = this;
      this.gridData = res.map(item => this.manageGrid(item, that));
    })
  }
  addNew() {
    this.router.navigate(["observe/newquota"]);
  }


  edit(dataItem) {
    this.router.navigate(["observe/editquota/" + dataItem.quotaID]);
  }


  openmodal(template: TemplateRef<any>) {
    this.mygroup.patchValue({
      selectedIns: this.selected
    })
    this.modalRef = this.modalService.show(template, Object.assign({}, { class: 'w-420' }));
  }

  OnInstitutionsChanges() {
    if (this.institutions && !this.itemChange) {
      this.itemChange = true;
      var roleId = this.config.userData.roleName.roleId;
      this.service.getInstitutionsbyId(this.institutions, roleId).subscribe((res: any) => {
        this.InstitutionsList = res;
        if (this.layoutService.institutionID) {
          this.institutionID = this.layoutService.institutionID
        } else {
          if (res.length > 0) {
            this.institutionID = res[0].institution.institutionID;
          }
        }

        this.onInstitutionChange(this.institutionID);
      })
    }
  }

  changeGridLang() {
    this.gridData.forEach((value, index) => {
      this.gridData[index].departmentNameTrl = this.layoutService.translateText(value.departmentName);
      this.gridData[index].wardTrl = this.layoutService.translateText(value.wardName);
    });
  }

  onInstitutionChange(value) {
    if (this.InstitutionsList) {
      this.layoutService.institutionID = value;
      this.layoutService.institutionIDSubject.next(value);
      this.selected = this.InstitutionsList.find(x => x.institution.institutionID === value).institution.institutionID;
      this.selectedInstitution = this.InstitutionsList.find(x => x.institution.institutionID === value).institution.institutionName;
    }
  }


  openDeleteModal(deletemodal: TemplateRef<any>, dataItem) {
    this.deleteDataItem = dataItem
    // this.deleterowIndex = rowIndex
    this.modalRef = this.modalService.show(deletemodal, Object.assign({}, { class: 'w-420' })
    )
  }

  delete() {
    this.service.deleteQuota(this.deleteDataItem.quotaID).subscribe((res: Ward) => {
      var data: any[] = JSON.parse(JSON.stringify(this.gridData));
      this.gridData = [];
      var index = data.findIndex(quota => quota.quotaID === this.deleteDataItem.quotaID);
      data.splice(index, 1);
      this.gridData = data;
    })
  }

  showInstitutionDropDown() {
    if (this.InstitutionsList) {
      if (this.InstitutionsList.length < 2) {
        return false;
      } else {
        return true;
      }
    }
  }

  getInstitutionName() {
    if (this.InstitutionsList) {
      return this.InstitutionsList[0].institution.institutionName;
    }
  }
  searchTextChange() {
    // this.isCollapsed = [false];
  }

  onSearchTextChanged(text: string): void {
    this.searchText = text;
  }

  manageGrid(item, that) {
    item.departmentName = this.layoutService.translateText(item.departmentName)

    let date = that.layoutService.convertUTCStingToLocalDate(item.startDateTime);
    let lang = localStorage.getItem('selectedlanguage') || 'en';
    if (lang === 'en') {
      lang = 'en-GB';
    }
    item.startDateTime = date.toLocaleDateString(lang, { month: 'short', day: 'numeric', year: 'numeric' });

    date = that.layoutService.convertUTCStingToLocalDate(item.endDateTime);
    item.endDateTime = date.toLocaleDateString(lang, { month: 'short', day: 'numeric', year: 'numeric' });

    let canShowDelete = true;
    let canShowEdit = true;
    if (item.status == 1 || item.status == 2) {
      canShowDelete = false;
    }
    if (item.status == 1) {
      canShowEdit = false;
    }
    let actionItems = JSON.parse(JSON.stringify(that.actionItems));
    if (!canShowDelete) {
      let removableIndex = actionItems.findIndex(el => el.name == "LAYOUT_MODULE.DELETE");
      actionItems.splice(removableIndex, 1);
    }
    if (!canShowEdit) {
      let removableIndex2 = actionItems.findIndex(el => el.name == that.translationKeys.LayoutModule.Edit);
      actionItems.splice(removableIndex2, 1);
    }
    let filtered = [];
    for (var arr in that.actionItems) {
      for (var filter in actionItems) {
        if (that.actionItems[arr].name == actionItems[filter].name) {
          filtered.push(that.actionItems[arr]);
        }
      }
    }
    item.actionItems = filtered;
    switch (item.status) {
      case 1:
        item.status = `${that.layoutService.translateText(that.translationKeys.Configure.Completed)}`;
        break;
      case 2:
        item.status = `${that.layoutService.translateText('INSTITUTION_MANAGEMENT.ACTIVE')}`;
        break;
      default:
        item.status = `${that.layoutService.translateText(that.translationKeys.Configure.Scheduled)}`;
        break;
    }

    return item;
  }

  toggleFilter() {
    this.showFilter = !this.showFilter;
    this.statuses = [... this.selectedStatuses];
  }

  getEventShowFilter(event) {
    this.showFilter = event.val;
    this.statuses = [... this.selectedStatuses];
  }

  selectStatus(status: number): void {
    if (status === 0) {
      this.statuses = [0];
      return;
    }
    if (this.statuses.length === 1 && this.statuses[0] === 0) {
      this.statuses = [];
    }
    const index = this.statuses.indexOf(status);
    if (index === -1) {
      this.statuses.push(status);
    } else {
      this.statuses.splice(index, 1);
    }
  }

  getStatusText(status: number): string {
    switch (status) {
      case 0:
        return this.layoutService.translateText('SOP_MANAGEMENT.ALL');
      case 1:
        return this.layoutService.translateText(this.translationKeys.Configure.Completed);
      case 2:
        return this.layoutService.translateText('INSTITUTION_MANAGEMENT.ACTIVE');
      case 3:
        return this.layoutService.translateText(this.translationKeys.Configure.Scheduled);
    }
  }

  selectDate() {
    if ((this.dateRange[0] == null && this.dateRange[1] == null) ||
      (this.dateRange[0] != null && this.dateRange[1] == null) ||
      (this.dateRange[0] == null && this.dateRange[1] != null))
      return;


  }

  checkDatesNotValid() {
    if (this.filterSubmitted)
      return (this.dateRange[0] != null && this.dateRange[1] == null) || (this.dateRange[0] == null && this.dateRange[1] != null);
  }

  saveFilter() {
    this.filterSubmitted = true;
    if (this.checkDatesNotValid()) {
      return;
    }
    this.selectedDateRange = [... this.dateRange];
    if (this.dateRange[0] != null && this.dateRange[1] != null) {
      this.range.start = new Date(this.selectedDateRange[0].getFullYear(), this.selectedDateRange[0].getMonth(), this.dateRange[0].getDate(), 0, 0, 0);
      this.range.end = new Date(this.selectedDateRange[1].getFullYear(), this.selectedDateRange[1].getMonth(), this.dateRange[1].getDate(), 23, 59, 59);
    } else {
      this.range.start = null;
      this.range.end = null;
    }
    this.selectedStatuses = [... this.statuses];
    this.setFilterCount();
    this.showFilter = !this.showFilter;
    this.getQuotasByInstitutionId();
    this.filterSubmitted = false;
  }

  private setFilterCount() {
    this.filterCount = this.selectedStatuses.length;
    if (this.selectedDateRange[0] && this.selectedDateRange[1] ) {
      this.filterCount += 1;
    }
  }

  clearDate() {
    this.resetDate();
    this.selectedDateRange = [null, null];
    this.filterCount = this.selectedStatuses.length;
    this.getQuotasByInstitutionId();
  }

  clearStatus(status) {
    this.statuses = this.statuses.filter(item => item !== status);
    this.selectedStatuses = [... this.statuses];
    this.setFilterCount();
    this.getQuotasByInstitutionId();
  }

  resetFilters() {
    this.statuses = [];
    this.resetDate();
    this.setFilterCount();
  }

  private resetDate() {
    this.dateRange = [null, null];
    this.range.start = null;
    this.range.end = null;
  }
}
